import { apiGet, apiPatch } from "./client";


export async function getTeacherById(teacherId) {
  return apiGet(`/teacher/${encodeURIComponent(teacherId)}`);
}

export async function saveTeacherOnboarding({
  teachingRoleId,
  grades,
  subjects,
  curricula,
  priorities,
}) {
  return apiPatch(
    "/teacher/me/onboarding",
    {
      teachingRoleId,
      grades,
      subjects,
      curricula,
      priorities,
    },
    undefined,
    { retry: false },
  );
}